<ng-container *ngComponentOutlet="exporting.component; inputs: exporting.inputs" />
